import { AnyAction, MiddlewareAPI, Middleware } from 'redux';
import { ReduxState } from 'types/redux';
import notification from 'handlers/notification/notificationActionCreator';
import getMessage, { MessageType } from 'constants/messages';
import { ApplicationNotesActionType } from './ActionTypes';
import { getApplicationNotes, DeleteApplicationNoteSuccessAction, closeApplicationNotePopup } from './ActionCreator';

const isDeleteApplicationNoteSuccessAction = (action: AnyAction): action is DeleteApplicationNoteSuccessAction =>
  action.type === ApplicationNotesActionType.DeleteApplicationNoteSuccess;

export const DeleteApplicationNotesSuccessMiddlewares = (({ dispatch, getState }: MiddlewareAPI<ReduxState>) => (
  next: (action: AnyAction) => any,
) => (action: AnyAction) => {
  const result = next(action);

  if (isDeleteApplicationNoteSuccessAction(action)) {
    const { loanOriginationSystemApplicationPage } = getState();

    const { notes, applicationData } = loanOriginationSystemApplicationPage;

    if (!applicationData) {
      return result;
    }
    notification.createNotification(getMessage(MessageType.ApplicationNoteDeleted), 'success', dispatch);

    dispatch(getApplicationNotes(applicationData.id, notes.search, notes.sortingType));
    dispatch(closeApplicationNotePopup());
  }

  return result;
}) as Middleware;
